// @flow
import { combineReducers } from 'redux';
import passwordLoginStatusReducers from './passwordLoginStatus';

const companyReducers = combineReducers({
  passwordLoginStatus: passwordLoginStatusReducers
});

export default companyReducers;
